import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../../contexts/AuthContext';
import { getAccessToken } from '../../awsAuth';

const DEFAULT_AVATAR_URL =
  'https://cvanto-photos.s3.us-east-1.amazonaws.com/DefaultAvatar/avatar.png';

// Reuses the same endpoints as the real Profile page (Profile.js):
// /api/account/:id for username+avatar, /api/follow/stats for
// followers/following, /api/listings/user/:id for the listings count
// (Profile.js derives listingsCount the same way — listings.length).
const SidebarProfileCard = () => {
  const { userId, isLoggedIn } = useAuth();
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    if (!isLoggedIn || !userId) {
      setProfile(null);
      return;
    }

    let cancelled = false;

    (async () => {
      try {
        const token = await getAccessToken();
        const headers = token ? { Authorization: `Bearer ${token}` } : {};

        const [accountRes, statsRes, listingsRes] = await Promise.all([
          axios.get(`/api/account/${userId}`, { headers }).catch(() => null),
          axios.get(`/api/follow/stats?target=${encodeURIComponent(userId)}`).catch(() => null),
          axios.get(`/api/listings/user/${userId}`, { headers }).catch(() => null),
        ]);

        if (cancelled) return;

        const listings = Array.isArray(listingsRes?.data) ? listingsRes.data : [];

        setProfile({
          username: accountRes?.data?.username || 'Користувач',
          avatar: accountRes?.data?.avatar || DEFAULT_AVATAR_URL,
          followers: Number(statsRes?.data?.followers || 0),
          following: Number(statsRes?.data?.following || 0),
          listingsCount: listings.length,
        });
      } catch {
        if (!cancelled) setProfile(null);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [isLoggedIn, userId]);

  if (!isLoggedIn || !profile) return null;

  return (
    <Link to="/profile" className="sidebar__profile-card" aria-label="Мій профіль">
      <div className="sidebar__profile-top">
        <img src={profile.avatar} alt="" className="sidebar__profile-avatar" />
        <div className="sidebar__profile-name">{profile.username}</div>
      </div>

      <div className="sidebar__profile-stats">
        <div className="sidebar__profile-stat">
          <strong>{profile.followers}</strong>
          <span>Підписники</span>
        </div>
        <div className="sidebar__profile-stat">
          <strong>{profile.following}</strong>
          <span>Підписки</span>
        </div>
        <div className="sidebar__profile-stat">
          <strong>{profile.listingsCount}</strong>
          <span>Оголошення</span>
        </div>
      </div>
    </Link>
  );
};

export default SidebarProfileCard;
